<template>
  <div class="backgroud-white">
    <div class="text-center">
      <br><span style="font-size:12px;color:#b5b5b5">请联系客服获取验证码</span>
    </div>
    <div class="backgroud-gray-popup popup-content-area-small">
      <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px" label-position="left">
          <el-form-item label="验证码" prop="token">
            <el-input placeholder="请输入验证码" v-model="form.token" class="input-width" size="small">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div slot="footer" class="dialog-footer popup-footer">
      <el-row>
        <el-col class="footer-center">
          <el-button :loading="isLoading" :disabled="submitBtnDisable" type="primary" @click="onConfirm">确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<style lang="scss" scoped>

</style>

<script>
import {
  generateAppointmentToken,
  validateVideoAppointmentToken
} from "../service/videoAppointment.service";
export default {
  props: {
    dataIn: {
      videoAppointmentId: Number
    }
  },
  compontents: {},
  data() {
    return {
      submitBtnDisable: false,
      isLoading: false,
      form: {
        token: ""
      },
      rules: {
        token: [
          {
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
      }
    };
  },
  computed: {

  },
  created() {
    this.init();
  },
  mounted() { },
  methods: {
    init() {
      this.submitBtnDisable = false;
      this.form.token = "";
      if (this.dataIn.videoAppointmentId){
        this.isLoading = true;
        generateAppointmentToken(this.dataIn.videoAppointmentId).then(result =>{
          if (result && result.success) {

          }else{
            if (result.message){
              this.$message.error("验证码生成失败,请联系客服."+ result.message);
            }else{
              this.$message.error("验证码生成失败,请联系客服.");
            }
          }
          this.isLoading = false;
        });
      }
    },
    onConfirm() {
      let valid = true;
      this.$refs.form.validate(v => {
        if (!v) {
          valid = false;
        }
      });
      if (!valid) return;
      this.submitBtnDisable = true;
      this.isLoading = true;
      validateVideoAppointmentToken(this.dataIn.videoAppointmentId, this.form.token).then(result => {
        if (result && result.success) {
          if (result.data) {
            this.$message.success("验证成功");
            this.$emit("tokenValid");
          } else {
            this.$message.warning("验证失败");
          }
         
        }else{
          if (result.message){
            this.$message({
              type: "error",
              dangerouslyUseHTMLString: true,
              message: "验证失败，"+ result.message
            });
          }else{
            this.$message.warning("验证失败");
          }
        }
        this.submitBtnDisable = false;
        this.isLoading = false;
      });
    }
  },
  watch: {
    dataIn: function () {
      this.init();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tokenEditor.vue